export default "__VITE_ASSET__B6oKmQY5__"